/**
 * Memoryzz Homepage Interactive JavaScript
 * Handles: Hero slider, tabs, testimonials carousel,
 * mobile drawer, search overlay, video autoplay,
 * scroll animations, and sticky header.
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ============================================
     HERO SLIDESHOW
     ============================================ */
  const heroTrack = document.getElementById('mz-hero-track');
  const heroSection = document.getElementById('mz-hero');
  if (heroTrack && heroSection) {
    const slides = heroTrack.querySelectorAll('.mz-hero__slide');
    const dots = document.querySelectorAll('#mz-hero-dots .mz-hero__dot');
    const prevBtn = document.getElementById('mz-hero-prev');
    const nextBtn = document.getElementById('mz-hero-next');
    let current = 0;
    let autoplayTimer = null;
    const autoplay = heroSection.querySelector('[data-autoplay]') !== null ||
                     true; // default on
    const speed = 5000;

    function goToSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      heroTrack.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === current);
      });
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(function() {
        goToSlide(current + 1);
      }, speed);
    }

    function stopAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() {
      goToSlide(current - 1);
      startAutoplay();
    });

    if (nextBtn) nextBtn.addEventListener('click', function() {
      goToSlide(current + 1);
      startAutoplay();
    });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(this.dataset.slide));
        startAutoplay();
      });
    });

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    heroTrack.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    heroTrack.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) goToSlide(current + 1);
        else goToSlide(current - 1);
        startAutoplay();
      }
    }, { passive: true });

    if (slides.length > 1) startAutoplay();
  }


  /* ============================================
     TABBED PRODUCTS
     ============================================ */
  const tabsContainer = document.getElementById('mz-tabs');
  if (tabsContainer) {
    const tabs = tabsContainer.querySelectorAll('.mz-tab');
    const panels = document.querySelectorAll('.mz-tab-panel');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        const index = this.dataset.tabIndex;

        tabs.forEach(function(t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        panels.forEach(function(panel) {
          panel.classList.toggle('active', panel.dataset.tabPanel === index);
        });
      });
    });
  }


  /* ============================================
     TESTIMONIALS CAROUSEL
     ============================================ */
  const testimonialTrack = document.getElementById('mz-testimonials-track');
  if (testimonialTrack) {
    const cards = testimonialTrack.querySelectorAll('.mz-testimonial-card');
    const prevBtn = document.getElementById('mz-testimonial-prev');
    const nextBtn = document.getElementById('mz-testimonial-next');
    let tPosition = 0;

    function getVisibleCount() {
      if (window.innerWidth >= 1024) return 3;
      if (window.innerWidth >= 768) return 2;
      return 1;
    }

    function moveTestimonials(direction) {
      const visible = getVisibleCount();
      const maxPos = Math.max(0, cards.length - visible);
      tPosition += direction;
      if (tPosition < 0) tPosition = 0;
      if (tPosition > maxPos) tPosition = 0; // loop back

      const cardWidth = cards[0].offsetWidth + 24; // gap
      testimonialTrack.style.transform = 'translateX(-' + (tPosition * cardWidth) + 'px)';
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { moveTestimonials(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { moveTestimonials(1); });

    // Auto-scroll testimonials
    let testimonialAutoplay = setInterval(function() { moveTestimonials(1); }, 4000);
    testimonialTrack.addEventListener('mouseenter', function() { clearInterval(testimonialAutoplay); });
    testimonialTrack.addEventListener('mouseleave', function() {
      testimonialAutoplay = setInterval(function() { moveTestimonials(1); }, 4000);
    });
  }


  /* ============================================
     MOBILE DRAWER
     ============================================ */
  const hamburger = document.getElementById('mz-hamburger');
  const drawer = document.getElementById('mz-mobile-drawer');
  const drawerClose = document.getElementById('mz-drawer-close');
  const drawerOverlay = document.getElementById('mz-drawer-overlay');

  function openDrawer() {
    if (drawer) drawer.classList.add('active');
    if (drawerOverlay) drawerOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('active');
    if (drawerOverlay) drawerOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  // Mobile accordion toggles
  document.querySelectorAll('.mz-mobile-nav__toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      this.classList.toggle('active');
      var sub = this.closest('.mz-mobile-nav__item').querySelector('.mz-mobile-nav__sub');
      if (sub) sub.classList.toggle('active');
    });
  });


  /* ============================================
     SEARCH OVERLAY
     ============================================ */
  const searchTrigger = document.getElementById('mz-search-trigger');
  const searchOverlay = document.getElementById('mz-search-overlay');

  if (searchTrigger && searchOverlay) {
    searchTrigger.addEventListener('click', function() {
      searchOverlay.classList.add('active');
      var input = searchOverlay.querySelector('input');
      if (input) setTimeout(function() { input.focus(); }, 100);
    });

    searchOverlay.addEventListener('click', function(e) {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove('active');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
        searchOverlay.classList.remove('active');
      }
    });
  }


  /* ============================================
     VIDEO CLICK TO PLAY
     ============================================ */
  const videoCards = document.querySelectorAll('.mz-video-card');
  if (videoCards.length > 0) {
    videoCards.forEach(function(card) {
      const video = card.querySelector('video');
      const playBtn = card.querySelector('.mz-video-card__play');

      if (video) {
        // Remove autoplay attributes just in case
        video.removeAttribute('autoplay');
        video.pause();

        // Sync state on native play
        video.addEventListener('play', function () {
          card.classList.add('is-playing');
          video.muted = false;
        });

        // Sync state on native pause
        video.addEventListener('pause', function () {
          card.classList.remove('is-playing');
        });

        // Handle click on the play button (or the card media)
        const mediaArea = card.querySelector('.mz-video-card__media');
        if (mediaArea) {
          mediaArea.addEventListener('click', function(e) {
            e.preventDefault();

            if (video.paused) {
              // Pause all other videos
              document.querySelectorAll('.mz-video-card video').forEach(function(v) {
                if (v !== video) {
                  v.pause();
                }
              });

              // Play this video
              video.play().catch(function (err) {
                console.log('Video play failed:', err);
              });
            } else {
              // Pause this video
              video.pause();
            }
          });
        }
      }
    });
  }


  /* ============================================
     SCROLL FADE-IN ANIMATIONS
     ============================================ */
  const fadeElements = document.querySelectorAll('.mz-fade-in');
  if (fadeElements.length > 0 && 'IntersectionObserver' in window) {
    const fadeObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mz-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    fadeElements.forEach(function(el) { fadeObserver.observe(el); });
  }


  /* ============================================
     STICKY HEADER SHADOW
     ============================================ */
  const header = document.getElementById('mz-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const scrollY = window.scrollY;
      if (scrollY > 10) {
        header.style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.08)';
      } else {
        header.style.boxShadow = '0 1px 4px rgba(0, 0, 0, 0.05)';
      }
      lastScroll = scrollY;
    }, { passive: true });
  }

});
